export default __webpack_public_path__ + "static/poster-3c7cc676c0cd935253867cd73ff18a10.png";